// https://github.com/vercel/next.js/issues/77291
import type { App } from '@unifyapps/defs/types/embeds';
import type { ExtensionApp } from '@unifyapps/defs/types/extensionApp';

export enum ClientType {
  Platform = 'PLATFORM',
  Matrix = 'MATRIX',
  MatrixExtension = 'MATRIX_EXTENSION',
  MatrixNative = 'MATRIX_NATIVE',
  DeltaMatrix = 'DELTA_MATRIX',
  DeltaPlatform = 'DELTA_PLATFORM',
  WebSdk = 'WEB_SDK',
  NativeSdk = 'NativeSdk',
  CsrApp = 'CSR_APP',
}

export type ClientContextValue = {
  /**
   * The client who's rendering the app
   */
  client?: ClientType;
  /**
   * The app inside which the client is rendering
   * Not applicable for PLATFORM or MATRIX
   */
  app?: ExtensionApp | App;
  value?: {
    client?:
      | ClientType.Platform
      | ClientType.Matrix
      | ClientType.MatrixNative
      | ClientType.MatrixExtension;
    app?: ExtensionApp;
  };
  /**
   * Whether the app is rendering in shadow dom
   */
  renderInShadowDom?: boolean;
};
